<div
  class="u-padding-default u-borderRadius-inner-card border-color-default u-border-default"
>
  <div class="u-marginBottom-default">
    <p
      [ngStyle]="{ 'font-weight': 400 }"
      class="text-heading-md u-marginBottom-small"
    >
      @if (programMembership.program_preferences?.program_roles?.length) {
        @if (isBothRoleOptionSelected(programMembership)) {
          <ng-container i18n="@@userOnboardingProgramForm.bothRolesTitle">
            You're invited to be a
            <strong>{{
              (
                programRoles
                | getCustomRoleFromProgramRoles
                  : programRoleMentor
                  : programMembership.program.program_config
              )?.label
            }}</strong>
            and a
            <strong>{{
              (
                programRoles
                | getCustomRoleFromProgramRoles
                  : programRoleMentee
                  : programMembership.program.program_config
              )?.label
            }}</strong>
            in the
            <strong>{{
              programMembership.program.name | liveTranslate: group._id | async
            }}</strong>
          </ng-container>
        } @else {
          <ng-container i18n="@@userOnboardingProgramForm.singleRoleTitle">
            You're invited to be a
            <strong>{{
              (
                programRoles
                | getCustomRoleFromProgramRoles
                  : programMembership.program_preferences?.program_roles?.join(
                      ','
                    )
                  : programMembership.program.program_config
              )?.label
            }}</strong>
            in the
            <strong>{{
              programMembership.program.name | liveTranslate: group._id | async
            }}</strong>
          </ng-container>
        }
      } @else {
        <strong>
          {{
            programMembership.program.name | liveTranslate: group._id | async
          }}
        </strong>
      }
    </p>
    <p class="text-body-md color-text-subdued">
      {{
        programMembership.program.description | liveTranslate: group._id | async
      }}
    </p>
  </div>
  @if (
    (isRoleSelectionEnabled &&
      !programMembership.program_preferences?.program_roles?.length) ||
    isEditMode
  ) {
    <app-program-participant-preferences-form
      [formControl]="preferencesForm"
      [group]="group"
      [program]="programMembership.program"
      [user]="user"
      [userProgramMembership]="programMembership"
      class="u-display-block"
    ></app-program-participant-preferences-form>
    <div
      class="u-marginTop-default"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="8px"
    >
      <button
        [appButtonShakeTrigger]="formSubmissionError$"
        [disabled]="isLoading"
        (click)="saveProgramMembership(preferencesForm, 'active')"
        color="primary"
        mat-raised-button
        type="submit"
        i18n="@@global.joinProgram"
      >
        Join program
      </button>
      <button
        [disabled]="isLoading"
        (click)="saveProgramMembership(preferencesForm, 'declined')"
        color="warn"
        mat-button
        type="button"
        i18n="@@global.decline"
      >
        Decline
      </button>
      @if (isLoading) {
        <i nz-icon nzSpin nzType="sync"></i>
      }
    </div>
  } @else {
    @if (programMembershipStatusActive === programMembership.status) {
      <div
        class="u-borderRadius-inner-card background-color-success u-padding-small-0 u-padding-0-default"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxLayoutGap="8px"
      >
        <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="8px">
          <mat-icon class="md-18 color-text-secondary"
            >check_circle_outline</mat-icon
          >
          <div fxLayout="column" fxLayoutGap="4px">
            <p class="u-textDecoration-bold text-body-md">
              @if (isBothRoleOptionSelected(programMembership)) {
                <ng-container
                  i18n="
                    @@userOnboardingProgramForm.bothRolesRegistrationConfirmation"
                >
                  You're registered in this program as a
                  {{
                    (
                      programRoles
                      | getCustomRoleFromProgramRoles
                        : programRoleMentor
                        : programMembership.program.program_config
                    )?.label
                  }}
                  and a
                  {{
                    (
                      programRoles
                      | getCustomRoleFromProgramRoles
                        : programRoleMentee
                        : programMembership.program.program_config
                    )?.label
                  }}
                </ng-container>
              } @else {
                @if (
                  !programMembership.program_preferences?.program_roles?.length
                ) {
                  <ng-container
                    i18n="
                      @@userOnboardingProgramForm.noRoleRegistrationConfirmation"
                  >
                    You're registered in this program
                  </ng-container>
                } @else {
                  <ng-container
                    i18n="
                      @@userOnboardingProgramForm.singleRoleRegistrationConfirmation"
                  >
                    You're registered in this program as a
                    {{
                      (
                        programRoles
                        | getCustomRoleFromProgramRoles
                          : programMembership.program_preferences?.program_roles?.join(
                              ','
                            )
                          : programMembership.program.program_config
                      )?.label
                    }}
                  </ng-container>
                }
              }
            </p>
            @if (isBothRoleOptionSelected(programMembership)) {
              <p class="color-text-subdued text-body-sm">
                @if (1 < programMembership.program_preferences?.capacity) {
                  <ng-container
                    i18n="
                      @@userOnboardingProgramForm.bothRoleMultipleCapacityLabel"
                  >
                    You have chosen to be matched with a maximum of
                    {{ programMembership.program_preferences?.capacity }}
                    {{
                      (
                        programRoles
                        | getCustomRoleFromProgramRoles
                          : programRoleMentee
                          : programMembership.program.program_config
                      )?.pluralLabel | lowercase
                    }}
                  </ng-container>
                } @else {
                  <ng-container
                    i18n="
                      @@userOnboardingProgramForm.bothRoleSingleCapacityLabel"
                  >
                    You have chosen to be matched with a maximum of
                    {{ programMembership.program_preferences?.capacity }}
                    {{
                      (
                        programRoles
                        | getCustomRoleFromProgramRoles
                          : programRoleMentee
                          : programMembership.program.program_config
                      )?.label | lowercase
                    }}
                  </ng-container>
                }
              </p>
            }
          </div>
        </div>
        <button (click)="isEditMode = true" color="basic" mat-raised-button>
          <mat-icon class="md-18" fontSet="material-icons-outlined"
            >edit</mat-icon
          >
          <span i18n="@@global.edit">Edit</span>
        </button>
      </div>
    } @else {
      <div
        class="u-borderRadius-inner-card background-color-surface-critical u-padding-small"
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="8px">
          <mat-icon
            class="md-18 color-text-critical"
            fontSet="material-icons-outlined"
            >cancel</mat-icon
          >
          <p
            class="u-textDecoration-bold text-body-md"
            i18n="@@userOnboardinProgramForm.declinedConfirmation"
          >
            You've declined to participate in this program
          </p>
        </div>
        <button (click)="isEditMode = true" color="basic" mat-raised-button>
          <mat-icon class="md-18" fontSet="material-icons-outlined"
            >edit</mat-icon
          >
          <span i18n="@@global.edit">Edit</span>
        </button>
      </div>
    }
  }
</div>
